import React from 'react';
import { Badge } from 'reactstrap';

function ClaimStatusField({ value, maxLength }) {
  if (!value) return <>-</>;

  if (value === 'CHECK') {
    return <Badge className="badge-compilation">Verificato</Badge>;
  } else if (value === 'SETTLED') {
    return <Badge className="badge-signed">Liquidato</Badge>;
  } else if (value === 'CLOSED') {
    return <Badge className="master-no">Chiuso senza seguito</Badge>;
  } else {
    return <>-</>;
  }
}

export default ClaimStatusField;
